import { soAtende } from '@mymaxx/shared';
import { Navigate, Route, Routes } from 'react-router';
import { Layout } from './componentes/Layout';
import { LayoutAtendente } from './componentes/LayoutAtendente';
import { RotaProtegida } from './componentes/RotaProtegida';
import { useSessao } from './lib/sessao';
import { Atendimento } from './paginas/Atendimento';
import { Atendimentos } from './paginas/Atendimentos';
import { Privacidade } from './paginas/Privacidade';
import { Relatorios } from './paginas/Relatorios';
import { Auditoria } from './paginas/Auditoria';
import { Configurar2fa } from './paginas/Configurar2fa';
import { TrocarSenha } from './paginas/TrocarSenha';
import { EditorFluxo } from './paginas/EditorFluxo';
import { Estacao } from './paginas/Estacao';
import { Fluxos } from './paginas/Fluxos';
import { DefinirSenha } from './paginas/DefinirSenha';
import { Inicio } from './paginas/Inicio';
import { Interno } from './paginas/Interno';
import { Login } from './paginas/Login';
import { MinhaConta } from './paginas/MinhaConta';
import { MonitorAgentes } from './paginas/MonitorAgentes';
import { Perfis } from './paginas/Perfis';
import { Setores } from './paginas/Setores';
import { Tecnicos } from './paginas/Tecnicos';
import { Usuarios } from './paginas/Usuarios';

export function App() {
  // Quem só atende trabalha na estação em tela cheia; quem supervisiona ou administra
  // continua no painel com menu, porque precisa navegar entre as telas.
  const somenteAtende = useSessao((e) => soAtende(e.usuario?.permissoes ?? []));

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/definir-senha" element={<DefinirSenha />} />
      <Route element={<RotaProtegida />}>
        {/* Fora do layout: quem está aqui ainda não pode navegar pelo painel. */}
        <Route path="/trocar-senha" element={<TrocarSenha />} />
        <Route path="/configurar-2fa" element={<Configurar2fa />} />

        {somenteAtende ? (
          <Route element={<LayoutAtendente />}>
            <Route path="/atendimentos" element={<Estacao />} />
            {/* Quem só atende também conversa com a equipe — sem esta rota, metade da
                operação não teria como largar o Telegram (07/10). */}
            <Route path="/interno" element={<Interno />} />
            <Route path="/minha-conta" element={<MinhaConta />} />
            <Route path="*" element={<Navigate to="/atendimentos" replace />} />
          </Route>
        ) : (
          <Route element={<Layout />}>
            <Route path="/" element={<Inicio />} />
            <Route path="/setores" element={<Setores />} />
            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/tecnicos" element={<Tecnicos />} />
            <Route path="/perfis" element={<Perfis />} />
            <Route path="/atendimento" element={<Atendimento />} />
            <Route path="/atendimentos" element={<Atendimentos />} />
            {/* Uma visão só: cartões por setor, com a fila e as intervenções dentro do
                cabeçalho e do cartão. A tela antiga, separada por setor, saiu. */}
            <Route path="/interno" element={<Interno />} />
            <Route path="/monitor" element={<MonitorAgentes />} />
            <Route path="/fluxos" element={<Fluxos />} />
            <Route path="/fluxos/:id" element={<EditorFluxo />} />
            <Route path="/relatorios" element={<Relatorios />} />
            <Route path="/auditoria" element={<Auditoria />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/minha-conta" element={<MinhaConta />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        )}
      </Route>
    </Routes>
  );
}
